import App from './App.svelte';
import Backend from './service/Backend.js'
import environment from 'environment';
import version from 'version';


const backend = new Backend(environment.backend)

const app = new App({
	target: document.body,
	props: {
		env: environment,
		backend: backend,
		frontendVersion: version
	}
});

export default app;
